import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import "./studentDetail.css";
import { Link } from "lucide-react";

export default function StudentDetail() {
  const { id } = useParams();

  const [data, setData] = useState(null);

  useEffect(() => {
    load();
  }, [id]);

  const load = async () => {
    const res = await axios.get(
      `https://bodhimaram.onrender.com/student-full/${id}`
    );
    setData(res.data);
  };

  if (!data) return <p>Loading...</p>;

  const { student, payments, total_paid, balance } = data;

  return (
    <div className="student_page">

      {/* 🔥 HEADER */}
      <div className="student_header">
        <img
          src={
            student.student_image
              ? `https://bodhimaram.onrender.com/uploads/students/${student.student_image}`
              : "/default.png"
          }
          alt=""
        />
        <div>
          <h2 className="st_na" >{student.childname}</h2>
          <p className="st_na" >Student ID: {student.st_id}</p>
        </div>
      </div>
      {/* 🔥 SUMMARY CARDS */}
      <div className="summary_cards">

        <div className="card purple">
          <p>Class</p>
          <h3>{student.group_code}</h3>
        </div>

        <div className="card blue">
          <p>Total Fees</p>
          <h3>₹{student.total_fees}</h3>
        </div>

        <div className="card green">
          <p>Paid Amount</p>
          <h3>₹{total_paid}</h3>
        </div>

        <div className="card orange">
          <p>Balance</p>
          <h3>₹{balance}</h3>
        </div>

      </div>

      {/* 🔥 TRANSACTIONS */}
      <div className="transactions_box">

        <div className="transactions_header">
          <h3>Payment Transactions</h3>
        
        </div>

        <table>
          <thead>
            <tr>
              <th>Date</th>
              <th>Time</th>
              <th>Mode</th>
              <th>Amount</th>
            </tr>
          </thead>

          <tbody>
            {payments.map((p, i) => {
              const date = new Date(p.created_at);
              return (
                <tr key={i}>
                  <td>{date.toLocaleDateString()}</td>
                  <td>{date.toLocaleTimeString()}</td>
                  <td>{p.payment_mode || "-"}</td>
                  <td>₹{p.amount}</td>
                </tr>
              );
            })}
          </tbody>
        </table>

      </div>
    </div>
  );
}